import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dropdown, Fade } from 'react-bootstrap'
import { IoIosClose } from 'react-icons/io'
import moment from 'moment'
import { useTranslation } from 'react-i18next';

import CustomButton from '../CustomButton';
import BellNotificationNode from './BellNotificationNode'

import { getUserNotifications, removeUserNotification, viewedUserNotifications } from '../../../../shared/api/action/ClientActions'
import { notificationsIcon } from '../helpers/iconHelpers'

import '../../../../app/layout/HeaderNav.sass'
import './NotificationsMenu.sass'

const NotificationsMenu = (props) => {
	const { user, notification, setUserNotifications, setDashboardRedirect, fullscreen, triggerClassName, triggerIcon, onOpenChange } = props
	const userRole = user.roles[0]
	const { t } = useTranslation('translation', { keyPrefix: 'components.headerNav' });

	const [hasViewedNotifications, setHasViewedNotifications] = useState(false);
	const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
	const [newNotifications, setNewNotifications] = useState([])
	const [earlierNotifications, setEarlierNotifications] = useState([])

	useEffect(() => {
		getNotifications()
		const interval = setInterval(() => {
			getNotifications()
		}, 600000)
		return () => clearInterval(interval)
	}, []);

	useEffect(() => {
		let session_notifications = notification.sessionNotifications.filter(({ status }) => status === 'active')
		if (notification.sessionNotifications.length) {
			session_notifications = session_notifications.sort((a, b) => moment(b.createtime).format('YYYYMMDDHHmmss') - moment(a.createtime).format('YYYYMMDDHHmmss'))
		}
		const new_notifications = notification.notifications.filter(({ status }) => status === 'active')
		const earlier_notifications = notification.notifications.filter(({ status }) => status === 'viewed')

		setNewNotifications(session_notifications.concat(new_notifications))
		setEarlierNotifications(earlier_notifications)
	}, [notification.notifications, notification.sessionNotifications])

	const getNotifications = () => {
		getUserNotifications()
			.then((res, err) => {
				const notifications = res.data.response.sort((a, b) => moment(b.createtime).format('YYYYMMDDHHmmss') - moment(a.createtime).format('YYYYMMDDHHmmss'))
				setUserNotifications(notifications)
			})
			.catch((error) => {
				console.log('!getNotifications error', error)
			})
	}

	const removeNotification = (e, id) => {
		if (typeof e.stopPropagation == "function") {
			e.stopPropagation();
		} else {
			e.cancelBubble = true;
		}

		const filtered = notification.notifications.filter(notification => notification.id != id * 1)
		setUserNotifications(filtered)
		removeUserNotification({ notification_id: id })
			.then((res, err) => {
				console.log('!removeNotification res', res, err)
			})
			.catch((error) => {
				console.log('!removeNotification error', error)
			})
	}

	const clearEarlierNotifications = async (e) => {
		const earlier_notifications = notification.notifications.filter(({ status }) => status === 'viewed');
		for (const n of earlier_notifications) {
			let res = await removeUserNotification({ notification_id: n.id })
			if (res) {
				console.log('!removeNotification res', res);
			}
			else {
				console.log(res);
			}
		}
		const new_notifications = notification.notifications.filter(({ status }) => status === 'active');
		setUserNotifications(new_notifications);
	}

	const clearNewNotifications = async (e) => {
		const new_notifications = notification.notifications.filter(({ status }) => status === 'active');
		for (const n of new_notifications) {
			let res = await removeUserNotification({ notification_id: n.id })
			if (res) {
				console.log('!removeNotification res', res);
			}
			else {
				console.log(res);
			}
		}
		const earlier_notifications = notification.notifications.filter(({ status }) => status === 'viewed');
		setUserNotifications(earlier_notifications);
	}

	const viewedNotifications = () => {
		viewedUserNotifications()
			.then((res, err) => {
				setHasViewedNotifications(true)
			})
			.catch((error) => {
				console.log('!viewedUserNotifications error', error)
			})
	}

	const notificationsList = (
		<>
			{newNotifications.length > 0
				&& <li className="group">
					{t('btnNew')}
					<CustomButton variant='link' prefix='clear-notifications' onClick={clearNewNotifications}>
						{t('btnClearAll')}
					</CustomButton>
				</li>
			}
			{newNotifications.length > 0
				&& newNotifications.map((item, index) => (
					<BellNotificationNode key={`new${index}`} userRole={userRole} removeNotification={removeNotification} setDashboardRedirect={setDashboardRedirect} {...item} />
				))
			}
			{earlierNotifications.length > 0
				&& <li className="group">
					{t('btnEarlier')}
					<CustomButton variant='link' prefix='clear-notifications' onClick={clearEarlierNotifications}>
						{t('btnClearAll')}
					</CustomButton>
				</li>
			}
			{earlierNotifications.length > 0
				&& earlierNotifications.map((item, index) => (
					<BellNotificationNode key={`earlier${index}`} userRole={userRole} removeNotification={removeNotification} setDashboardRedirect={setDashboardRedirect} {...item} />
				))
			}
			{!newNotifications.length && !earlierNotifications.length &&
				<div className='empty-notifications'>
					{t('btnNoUserNotifications')}
				</div>
			}
		</>
	)

	const unreadBubble = (newNotifications.length > 0 && !hasViewedNotifications) &&
		<span className="alert-bubble">{newNotifications.length}</span>

	if (fullscreen) {
		const openPanel = () => {
			setNotificationDropdownOpen(true)
			viewedNotifications()
			onOpenChange && onOpenChange(true)
		}

		const closePanel = () => {
			setNotificationDropdownOpen(false)
			onOpenChange && onOpenChange(false)
		}

		return (
			<>
				<button
					type="button"
					className={triggerClassName}
					aria-label="Notifications"
					onClick={notificationDropdownOpen ? closePanel : openPanel}
				>
					{triggerIcon || notificationsIcon}
					{unreadBubble}
				</button>
				<div className={`mobile-fullscreen-menu ${notificationDropdownOpen ? 'open' : ''}`}>
					<div className="mobile-fullscreen-menu-header">
						<button
							type="button"
							className="mobile-menu-sheet-close"
							title="Close"
							onClick={closePanel}
						>
							<IoIosClose aria-hidden="true" />
							<span className="sr-only">Close</span>
						</button>
					</div>
					<ul className="notifications-menu mobile-fullscreen-menu-body">
						{notificationsList}
					</ul>
				</div>
			</>
		)
	}

	return (
		<Dropdown
			id="user-notifications-btn"
			className='notifications-dropdown'
			pull-right="true"
			role="menuitem"
			onToggle={isOpen => {
				!isOpen && viewedNotifications();
				setNotificationDropdownOpen(isOpen);
			}}
		>
			<Dropdown.Toggle
				className='dropdown-toggle notifications-toggle'
				bsPrefix="no-caret"
				variant="outline"
				aria-controls='notification-dropdown'
			>
				{notificationsIcon}
				{unreadBubble}
			</Dropdown.Toggle>
			<Fade in={notificationDropdownOpen}>
				<Dropdown.Menu className="dropdown-menu notifications-menu">
					{notificationsList}
				</Dropdown.Menu>
			</Fade>
		</Dropdown>
	)
}

const mapStateToProps = (state) => ({
	user: state.user.user,
	notification: state.notification,
})

const mapDispatchToProps = (dispatch) => ({
	setUserNotifications: (state) => {
		dispatch({ type: 'SET_USER_NOTIFICATIONS', payload: state });
	},
	setDashboardRedirect: (state) => {
		dispatch({ type: 'SET_DASHBOARD_REDIRECT', payload: state });
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsMenu);
